import { SiteContext } from 'four-nets'
import React, { useContext } from 'react'
import { Link } from 'react-router-dom'

export const TryNewDemanderBox = () => {

    const site = useContext(SiteContext)

    if (site.isWedding)
        return (
            <Link
                to={site.isCzech ? '/magazine/hledas-dodavatele-novy-svatebni-poptavac-vyresi-tve-starosti' : '/magazine/hladas-dodavatela-svadobny-dopytovac-vyriesi-tvoje-starosti'}
                className='no-underline text-gray-900 my-2'
            >
                <div className="hover:bg-gray-50 rounded-xl shadow-lg py-5 px-5 bg-white">
                    <span className="font-semibold text-pink-700 block mb-2">
                        {site.isSlovak ? 'Vyskúšaj našu novinku!' : 'Vyzkoušej naši novinku!'}
                    </span>
                    <div className="flex items-center">
                        {site.isSlovak ? (
                            <>
                                <img
                                    className="object-cover mr-4 rounded-md"
                                    style={{ height: 70, width: 70 }}
                                    sizes="(min-width: 48rem) 280px,100vw"
                                    alt={site.isSlovak ? "Svadobný dopytovač" : "svatební poptávač"}
                                    src="https://mojasvadba.zoznam.sk/wp-content/uploads/2022/03/www.mojasvadba.sk_-768x432.png"
                                    srcSet="https://mojasvadba.zoznam.sk/wp-content/uploads/2022/03/www.mojasvadba.sk_-300x169.png 300w,https://mojasvadba.zoznam.sk/wp-content/uploads/2022/03/www.mojasvadba.sk_-1024x576.png 1024w,https://mojasvadba.zoznam.sk/wp-content/uploads/2022/03/www.mojasvadba.sk_-150x150.png 150w,https://mojasvadba.zoznam.sk/wp-content/uploads/2022/03/www.mojasvadba.sk_-768x432.png 768w,https://mojasvadba.zoznam.sk/wp-content/uploads/2022/03/www.mojasvadba.sk_-1536x864.png 1536w,https://mojasvadba.zoznam.sk/wp-content/uploads/2022/03/www.mojasvadba.sk_-2048x1152.png 2048w,https://mojasvadba.zoznam.sk/wp-content/uploads/2022/03/www.mojasvadba.sk_-1200x675.png 1200w,https://mojasvadba.zoznam.sk/wp-content/uploads/2022/03/www.mojasvadba.sk_-1980x1114.png 1980w"
                                />
                                <p className="text-sm">Hľadáš dodávateľa?<br />Nový svadobný dopytovač vyrieši tvoje starosti!</p>
                            </>) : (<>
                                <img
                                    className="object-cover mr-4 rounded-md"
                                    style={{ height: 70, width: 70 }}
                                    sizes="(min-width: 48rem) 280px,100vw"
                                    alt={site.isSlovak ? "Svadobný dopytovač" : "svatební poptávač"}
                                    src="https://beremese.cz/wp-content/uploads/2022/03/Beremese-dopytovac-768x432.png"
                                    srcSet="https://beremese.cz/wp-content/uploads/2022/03/Beremese-dopytovac-300x169.png 300w,https://beremese.cz/wp-content/uploads/2022/03/Beremese-dopytovac-1024x576.png 1024w,https://beremese.cz/wp-content/uploads/2022/03/Beremese-dopytovac-150x150.png 150w,https://beremese.cz/wp-content/uploads/2022/03/Beremese-dopytovac-768x432.png 768w,https://beremese.cz/wp-content/uploads/2022/03/Beremese-dopytovac-1536x864.png 1536w,https://beremese.cz/wp-content/uploads/2022/03/Beremese-dopytovac-2048x1152.png 2048w,https://beremese.cz/wp-content/uploads/2022/03/Beremese-dopytovac-1200x675.png 1200w,https://beremese.cz/wp-content/uploads/2022/03/Beremese-dopytovac-1980x1114.png 1980w"
                                />
                                <p className="text-sm">Hledáš dodavatele?<br />Nový svatební poptávač vyřeší tvé starosti!</p>
                            </>
                        )}
                    </div>
                </div>
            </Link>
        )

    return null
}